var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{attrs:{"placeholder":_vm.placeholder},on:{"input":_vm.onInput},model:{value:(_vm.bindValue),callback:function ($$v) {_vm.bindValue=$$v},expression:"bindValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }